export default __webpack_public_path__ + "static/media/company.d598793a.png";